// MUI
import { GridColDef } from "@mui/x-data-grid-pro";

// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// types
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";
import { ClassNameHints } from "@/Common/types/tables";

type TOnScheduleNotOnLotTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

const columns: (GridColDef & { hints?: Partial<ClassNameHints> })[] = [
	{
		field: "_id",
		headerName: "ID",
	},
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },
	{
		field: "manuallyReconciled",
		headerName: "",
		editable: true,
	},
	{
		field: "vinNumber",
		headerName: "VIN",
		width: 120,
	},
	{
		field: "stockNumber",
		headerName: "Stock #",
		width: 110,
	},
	{
		field: "balance",
		headerName: "Balance",
		headerAlign: "left",
		width: 100,
		type: "number",
		align: "right",
		hints: { isMoney: true, noFocus: true, noWrap: true },
	},
	{
		field: "year",
		headerName: "Year",
		headerAlign: "right",
		align: "right",
		width: 80,
		cellClassName: "!ps-6",
	},
	{
		field: "_empty",
		headerName: "",
		width: 15,
	},
	{
		field: "make",
		headerName: "Make",
		width: 110,
	},
	{
		field: "model",
		headerName: "Model",
		width: 120,
	},
	{
		field: "color",
		headerName: "Color",
		width: 110,
	},
	{
		field: "reason",
		headerName: "Reason",
		width: 140,
		editable: true,
	},
	{
		field: "resolution",
		headerName: "Resolution",
		width: 150,
		editable: true,
	},
	{
		field: "notes",
		headerName: "Notes",
		width: 70,
		editable: true,
	},
];

export default function OnScheduleNotOnLotTable(props: TOnScheduleNotOnLotTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;
	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="onScheduleNotOnLot"
		/>
	);
}
